/// \file SecurityAdminEvents.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2025 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const SecurityAdminEventsList = lazy(() => import('../views/security-admin-events/list/view'));

async function SecurityAdminEventsDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/security-admin-events/list/loader')).default;
  return actualLoader(args);
}

export async function SecurityAdminEventsAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/security-admin-events/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="SecurityAdminEvents"
    handle={{
      text: 'Security Admin Events'
      }}
  >
    <Route 
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <SecurityAdminEventsList />
        </Suspense>
      }     
      loader={SecurityAdminEventsDataLoader}
      action={SecurityAdminEventsAction}
      />
  </Route>
);

export default routes;